import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    map as _$ma,
    className as _$cn,
} from 'intact';
import {TransitionGroup, Transition} from 'intact';
import {makeMessagesStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$cc(TransitionGroup, {
            'children': (
                _$ma(this.messages, function($value, $key) {
                    return $value;
                }, $this)
            )
        })
    ), 2, _$cn({"k-messages": true, [makeMessagesStyles()]: true}));
};